import React from 'react';
import { Button, Card, Tag } from 'antd';

// Ключи типов — из канонической модели umowy (type: 'zlecenie'|'uop'|'b2b').
const TYPE_LABELS = {
    zlecenie: 'Umowa zlecenie',
    uop: 'Umowa o pracę',
    b2b: 'B2B',
};

// Статус «podpisana» в базе не хранится — он выводится из наличия
// podpis.signedAt, поэтому карточка сама считает effective-статус.
const STATUS_META = {
    podpisana: { label: 'Podpisana', color: 'green' },
    wyslana: { label: 'Oczekuje na podpis', color: 'gold' },
    szkic: { label: 'Szkic', color: 'default' },
    zakonczona: { label: 'Zakończona', color: 'default' },
    anulowana: { label: 'Anulowana', color: 'red' },
};

// Даты в модели лежат как 'YYYY-MM-DD' (okres) и ISO (podpis.signedAt) —
// обе корректно парсятся Date, показываем в польском формате.
const formatDate = (value) => {
    if (!value) return null;
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? value : date.toLocaleDateString('pl-PL');
};

const UmowaCard = ({ umowa, onOpenPdf, onSign }) => {
    const effectiveStatus = umowa.podpis?.signedAt ? 'podpisana' : umowa.status;
    const status = STATUS_META[effectiveStatus] || { label: effectiveStatus || '—', color: 'default' };
    // Подписывать можно только отправленную и ещё не подписанную умову.
    const canSign = umowa.status === 'wyslana' && !umowa.podpis;
    // okresDo = null означает «na czas nieokreślony».
    const okres = umowa.okresDo
        ? `${formatDate(umowa.okresOd)} – ${formatDate(umowa.okresDo)}`
        : `od ${formatDate(umowa.okresOd)} (na czas nieokreślony)`;

    return (
        <Card
            title={TYPE_LABELS[umowa.type] || 'Umowa'}
            extra={<Tag color={status.color} style={{ marginRight: 0 }}>{status.label}</Tag>}
            style={{ marginBottom: '16px' }}
        >
            <p style={{ margin: '0 0 4px' }}>
                <span className="detail-label">Okres: </span>{okres}
            </p>
            {effectiveStatus === 'podpisana' && (
                <p style={{ margin: '0 0 4px' }}>
                    <span className="detail-label">Podpisano: </span>{formatDate(umowa.podpis.signedAt)}
                </p>
            )}
            <div style={{ marginTop: '12px', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                {umowa.pdfUrl && (
                    <Button onClick={() => onOpenPdf(umowa)}>Otwórz PDF</Button>
                )}
                {canSign && (
                    <Button type="primary" onClick={() => onSign(umowa)}>Podpisz</Button>
                )}
            </div>
        </Card>
    );
};

export default UmowaCard;
